import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import DashboardGuest from './views/DashboardGuest.vue'
import eTerminal from './views/eTerminal.vue'
import Login from './views/Login.vue'
import TransactionsV2 from './views/TransactionsV2.vue'
import Transactions from './views/Transactions.vue'
import TransactionsV2Alto from './views/TransactionsV2Alto.vue'
import TransactionsNetbanx from './views/TransactionsNetbanx.vue'
import CriticalTransactions from './views/CriticalTransactions.vue'
import Chargebacks from './views/Chargebacks.vue'
import ServerToServerTest from './views/ServerToServerTest.vue'
import ServerToServerLive from './views/ServerToServerLive.vue'
import ServerToServerRegistration from './views/ServerToServerRegistration.vue'
import TransactionsValueReport from './views/TransactionsValueReport.vue'
import TransactionsVolumeReport from './views/TransactionsVolumeReport.vue'
import ValueVolumeComparisonReport from './views/ValueVolumeComparisonReport.vue'
import TransactionsFrequencyReport from './views/TransactionsFrequencyReport.vue'
import SalesStaffReport from './views/SalesStaffReport.vue'
import LeadsStatusReport from './views/LeadsStatusReport.vue'
import SmsReport from './views/SmsReport.vue'
import OnBoarder from './views/OnBoarder.vue'
import Holidays from './views/Holidays.vue'
import HolidayRequests from './views/HolidayRequests.vue'
import HolidayAllowances from './views/HolidayAllowances.vue'
import CsvParser from './views/CsvParser.vue'
import PayByLink from './views/PayByLink.vue'
import PayByLinkPayment from './views/PayByLinkPayment.vue'
import RegByLink from './views/RegByLink.vue'
import SendInvoices from './views/SendInvoices.vue'
import store from './store.js'

Vue.use(Router)

const router = new Router({

  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.page_access.split(",").indexOf('1') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/dashboard-guest',
      name: 'dashboard-guest',
      component: DashboardGuest,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          next();
        }
        else {
          next('/login');
        }
      }
    },
    {
      path: '/transactions-v2',
      name: 'transactions-v2',
      component: TransactionsV2,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.page_access.split(",").indexOf('3') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: Transactions,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.page_access.split(",").indexOf('2') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/transactions-v2-alto',
      name: 'transactions-v2-alto',
      component: TransactionsV2Alto,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.page_access.split(",").indexOf('13') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/transactions-netbanx',
      name: 'transactions-netbanx',
      component: TransactionsNetbanx,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.page_access.split(",").indexOf('14') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/chargebacks',
      name: 'chargebacks',
      component: Chargebacks,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.page_access.split(",").indexOf('14') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/critical-transactions',
      name: 'critical-transactions',
      component: CriticalTransactions,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.page_access.split(",").indexOf('4') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/eterminal',
      name: 'eTerminal',
      component: eTerminal,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.page_access.split(",").indexOf('5') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/server-to-server-test',
      name: 'server-to-server-test',
      component: ServerToServerTest,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('11') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/server-to-server-live',
      name: 'server-to-server-live',
      component: ServerToServerLive,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('16') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/server-to-server-registration',
      name: 'server-to-server-registration',
      component: ServerToServerRegistration,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('17') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/transactions-value-report',
      name: 'transactions-value-report',
      component: TransactionsValueReport,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('1') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/transactions-volume-report',
      name: 'transactions-volume-report',
      component: TransactionsVolumeReport,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('2') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/value-volume-comparison-report',
      name: 'value-volume-comparison-report',
      component: ValueVolumeComparisonReport,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('4') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/transactions-frequency-report',
      name: 'transactions-frequency-report',
      component: TransactionsFrequencyReport,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('3') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/leads-status-report',
      name: 'leads-status-report',
      component: LeadsStatusReport,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('5') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/sms-report',
      name: 'sms-report',
      component: SmsReport,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('5') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/sales-staff-report',
      name: 'sales-staff-report',
      component: SalesStaffReport,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('14') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/onboarder',
      name: 'onboarder',
      component: OnBoarder,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('6') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/holidays',
      name: 'holidays',
      component: Holidays,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('7') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/holiday-requests',
      name: 'holiday-requests',
      component: HolidayRequests,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('13') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/holiday-allowances',
      name: 'holiday-allowances',
      component: HolidayAllowances,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('18') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/csv-parser',
      name: 'csv-parser',
      component: CsvParser,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('15') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/send-invoices',
      name: 'send-invoices',
      component: SendInvoices,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('31') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/pay-by-link',
      name: 'pay-by-link',
      component: PayByLink,
      beforeEnter(to, from, next) {
        if(localStorage.token) {
          if(localStorage.sub_page_access.split(",").indexOf('19') == -1 && localStorage.page_access != 'null') {
            next('/dashboard-guest');
          }
          else {
            next();
          }
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/pay-by-link-payment/:id',
      name: 'pay-by-link-payment',
      component: PayByLinkPayment,
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/reg-by-link/:id',
      name: 'reg-by-link',
      component: RegByLink,
      meta: {
        navigation: false
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter(to, from, next) {
        if(!localStorage.getItem('token')) {
          next();
        }
        else {
          next('/');
        }
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Login,
      beforeEnter(to, from, next) {
        if(localStorage.getItem('token')) {
          localStorage.clear();
          router.push("login")
        }
        else {
          next('/');
        }
      }
    }
  ],
  mode: 'history'
})

router.beforeResolve((to, from, next) => {

  if(localStorage.token && from.name != 'login' && to.name != 'login' && to.name != 'reg-by-link') {
    store.dispatch('autoLogin')
    .then(response => {
      if(response) {
        store.dispatch('getNavigation');
        next();
      }
      else {
        router.go('/login');
      }
    })
    .catch(err => {
      console.log(err);
    });
  }
  else if(from.name && !localStorage.token) {
    router.go('/login');
  }
  else {
    next();
  }
});

export default router;